import { Button } from '@components/ui/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface IHeaderProps {
  pdfName: string;
}

function Header(props: IHeaderProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleBack() {
    navigate(-1);
  }

  return (
    <header className="header fixed w-full left-0 top-0 z-50 bg-xircle-main text-[#eee] p-3 shadow-md flex justify-between items-center h-20">
      <section className="brand flex items-center gap-2 text-lg font-bold">
        <span className="text-2xl pl-2">{props.pdfName}</span>
      </section>
      <Button className="bg-xircle-secondary border-none" onClick={handleBack}>
        {t('common.back')}
      </Button>
    </header>
  );
}

export default Header;
